module.exports = __webpack_public_path__ + "img/horizontal_4_7_pp2_7005.563fc1a2.png";